import { client } from './api-client';

export const mggFetchPremieresVideos = (category_id, limit, offset) => {
  const _category_id = category_id ? `&category_id=${category_id}` : '';
  const _limit = limit ? `&limit=${limit}` : '';
  const _offset = offset ? `&offset=${offset}` : '';

  return client.get(`mgg/premieres?${_category_id}${_limit}${_offset}`);
};
